'use client'
import { configs } from '@/configs'
import { addSubscriber } from '@/hooks/useAuth/zustand'
import { BrowserOptions } from '@sentry/nextjs'
import * as Sentry from '@sentry/nextjs'

console.log('Subscribing sentry user')
addSubscriber((state) => {
  const user = state.user
  if (user) {
    Sentry.setUser({
      email: user.email,
      id: user.id,
    })
    console.log({ userSubscribed: user })
  }
})

export const sentryBasicConfigs: BrowserOptions = {
  dsn: configs.SENTRY_DNS,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  environment: (() => {
    if (configs.IS_DEVELOPMENT) return 'development'
    if (configs.IS_HOMOLOG) return 'homologation'
    return 'production'
  })(),
  // Enable when needed for development tests
  enabled: !configs.IS_DEVELOPMENT,
}
